import React, { useState, useRef, useEffect, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../Header/Header1";
import Footer from "../Footer/footer";
import axios from "axios";
import "./dashboard.scss";
import Sidebar from "../SideBar/SideBar";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  InputAdornment,
  Switch,
  FormControlLabel,
} from "@mui/material";
// import Grid from '@mui/material/Grid';
import Grid from "@mui/material/Grid";
import trending_icon from "../../Img/trending_icon.svg";
import right_arw from "../../Img/right_arw.svg";
import zec from "../../Img/coins/zec.png";
import xec from "../../Img/coins/xec.png";
import kcs from "../../Img/coins/kcs.png";
import scr from "../../Img/coins/scr.png";
import cat from "../../Img/coins/cat.png";
import woop from "../../Img/coins/woop.png";
import pip from "../../Img/coins/pip.png";
import insp from "../../Img/coins/xec.png";
import ese from "../../Img/coins/ese.png";
import sol from "../../Img/coins/sol.png";
import usdt from "../../Img/usdt.png";
import Loader from "../Loader";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import d1 from "../../Img/d1.jpg";
import eye from "../../Img/eye.svg";
import eye_hide from "../../Img/eye_hide.svg";
import das_reward from "../../Img/das_reward.png";
import { Copy } from "../../SvgCollection";
import { toast, ToastContainer } from "react-toastify";
import usercalls from "../../Axios";
import consts from "../../constant";
import { decryptData } from "../../middleware";
import { useUserData } from "../../Contexts/UserContext";
import copy from "copy-text-to-clipboard";
import ImageWithFallback from "../FallbackImage/ImageWithFallback";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import Footernew from "../Footer/Footernew";

export default function Dashboard() {
  const [hideZero, setHideZero] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [load, setLoad] = useState(false);
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(5); // Rows per page
  const path = usercalls();
  const { userData, setUserData } = useUserData();
  // const userData = JSON.parse(decryptData(localStorage.getItem("user")));
  // console.log(userDeatils, "details");

  const [imghide, setimghide] = useState([
    { show: true },
    { show: false },
    { show: false },
  ]);

  const assetData = [
    {
      title: "Spot Assets",
      balance: "0.0000",
      depositLink: "/deposit",
      withdrawLink: "/withdraw",
    },
  ];

  const showimg = (i) => {
    setimghide((prevData) =>
      prevData.map((item, index) =>
        index === i ? { ...item, show: !item.show } : item
      )
    );
  };
  const [imageUrl, setImageUrl] = useState(null);

  const navigate = useNavigate();

  // Function to handle image upload
  const handleImageUpload = async (event) => {
    const file = event.target.files[0]; // Get the uploaded file

    if (file) {
      // setLoad(true);
      const formData = new FormData();
      formData.append("image", file);
      const validateToken = localStorage.getItem("Rikosta");
      const response = await axios
        .post(`${consts.BackendUrl}/users/profileImageUpload`, formData, {
          headers: {
            Authorization: `${validateToken}`,
          },
        })
        .then((res) => res.data);
      if (response.success) {
        setUserData((prev) => {
          return { ...prev, profilePicture: response.result };
        });
        // setLoad(false);
      }
    }
  };
  const data = [
    {
      id: 1,
      currencyName: "ZEC",
      currencySymbol: "ZEC",
      availableBalance: 0.0,
      icon: zec,
    },
    {
      id: 2,
      currencyName: "XEC",
      currencySymbol: "XEC",
      availableBalance: 0.0,
      icon: xec,
    },
    {
      id: 3,
      currencyName: "KCS",
      currencySymbol: "KCS",
      availableBalance: 0.0,
      icon: kcs,
    },
    {
      id: 4,
      currencyName: "SCR",
      currencySymbol: "SCR",
      availableBalance: 0.0,
      icon: scr,
    },
    {
      id: 5,
      currencyName: "CAT",
      currencySymbol: "CAT",
      availableBalance: 0.0,
      icon: cat,
    },
    {
      id: 6,
      currencyName: "WOOP",
      currencySymbol: "WOOP",
      availableBalance: 0.0,
      icon: woop,
    },
    {
      id: 7,
      currencyName: "PIP",
      currencySymbol: "PIP",
      availableBalance: 0.0,
      icon: pip,
    },
    {
      id: 8,
      currencyName: "INSP",
      currencySymbol: "INSP",
      availableBalance: 0.0,
      icon: insp,
    },
    {
      id: 9,
      currencyName: "ESE",
      currencySymbol: "ESE",
      availableBalance: 0.0,
      icon: ese,
    },
    {
      id: 10,
      currencyName: "SOL",
      currencySymbol: "SOL",
      availableBalance: 0.0,
      icon: sol,
    },
  ];

  const [datas, setDatas] = useState([]);
  const [walletLoading, setWalletLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [totalUSDT, setTotalUSDT] = useState(0);
  const [totalAsset, setTotalAsset] = useState("");
  const [totalAss, setTotalAss] = useState("");

  const getWalletsData = async (search) => {
    try {
      // get wallets data
      setLoad(true);
      setWalletLoading(true);
      setDatas([]);
      setTotalCount(0);
      const url = `${consts.BackendUrl}/wallet/OwnWalletGet?page=${page + 1
        }&limit=10`;
      const response = await path.postCall({
        url,
        payload: {
          search: search ? search : "",
          hideZero,
          changeType: "spot",
        },
      });
      const result = await response.json();
      if (result.success) {
        setDatas(result.result.docs);
        setTotalCount(result?.result?.totalDocs);
        setTotalUSDT(result?.grandTotal);
        var res = result.result.docs;
        var objs = {};
        var arrs = [];
        for (let i = 0; i < res?.length; i++) {
          const element = res[i];
          if (element?.spot_balance > 0) {
            objs[`${element?.symbol}USDT`] = element?.spot_balance;
            arrs.push(`${element?.symbol}USDT`);
            setLoad(false);
          }
        }
        // console.log(arrs, "arrs");
        setTotalAsset(arrs);
        setTotalAss(objs);
        // console.log(objs, "objsobjs");
        setLoad(false);
      }
      setWalletLoading(false);
      setLoad(false);
    } catch (error) {
      setWalletLoading(false);
      setLoad(false);
      console.log("🚀 ~ getWalletsData ~ error:", error);
    }
  };

  // useEffect(() => {
  //   const fetchBnbPrice = async () => {
  //     try {
  //       setLoad(true);
  //       if (totalAsset?.length > 0) {
  //         const response = await axios.get(
  //           `https://api.binance.com/api/v3/ticker/price?symbols=${JSON?.stringify(
  //             totalAsset
  //           )}`
  //         );
  //         console.log(response?.data, "teststeets");
  //         var resdata = response?.data;
  //         if (resdata?.length > 0) {
  //           var total = 0;
  //           for (let i = 0; i < resdata?.length; i++) {
  //             const element = resdata[i];
  //             total += totalAss[`${element?.symbol}`] * element?.price;
  //           }
  //           setLoad(false);
  //           setTotalUSDT((total + totalUSDT)?.toFixed(4));
  //         }
  //         setLoad(false);
  //         // setBnbPriceInUsdt(parseFloat(response.data.price)); // Get the price of BNB in USDT
  //       }
  //     } catch (error) {
  //       console.error("Error fetching BNB price from Binance API:", error);
  //       setLoad(false);
  //     }
  //   };

  //   fetchBnbPrice();
  // }, [totalAsset]);

  // Debounced function

  const debouncedSubmit = useCallback(
    debounce((value) => {
      getWalletsData(value);
    }, 300), // 300ms debounce delay
    []
  );

  // Utility function for debouncing
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Effect to call debounced function when search changes
  useEffect(() => {
    debouncedSubmit(searchTerm);
  }, [searchTerm, debouncedSubmit]);

  useEffect(() => {
    getWalletsData();
  }, [page, hideZero]);

  const filteredData = data.filter((row) => {
    const matchesSearch = row.currencyName
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const hasBalance = hideZero ? row.availableBalance > 0 : true;
    return matchesSearch && hasBalance;
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page when rows per page changes
  };

  const [accName, setAccName] = useState("UTX360778");
  const handleCopyAcc = (data) => {
    // navigator.clipboard.writeText(accName).then(() => {
    copy(data);
    return toast.success("Text Copied");
    // });
  };

  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const options = {
    loop: false,
    nav: false,
    dots: false,
    items: 1,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
  };

  // const getUserdata = async () => {
  //   try {
  //     const response = await path.getCallWithToken({
  //       url: `${consts.BackendUrl}/users/get_profile`,
  //     });
  //     console.log(response);

  //     const result = await response.json();
  //     console.log(result.result, "result");

  //     if (result.success) {
  //       setUserData(result.result);
  //     }
  //   } catch (error) {
  //     console.log("🚀 ~ getUserdata ~ error:", error);
  //   }
  // };

  // useEffect(() => {
  //   getUserdata();
  // }, []);

  return (
    <div className="menu-responsive">
      <div>
        <Header profilePicture={userData?.profilePicture} />
        {walletLoading && <Loader />}
        <ToastContainer />
        <div className="main_flx">
          <Sidebar />

          <div className="dash_board split_half">
            <div className="user_detail_box box_bdr mb-4">
              <div className="user_name">
                <div className="upload">
                  <div className="img">
                    <img
                      src={
                        userData?.profilePicture ? userData?.profilePicture : d1
                      }
                      alt={userData?.name[0]?.toUpperCase()}
                    />
                  </div>
                  <div className="upimg">
                    <svg
                      width="83"
                      height="137"
                      viewBox="0 0 83 137"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M39.1685 19.2212L13.8332 51.7062C12.9007 52.7942 11.5018 52.9497 10.5692 52.1725C9.48119 51.3953 9.32575 49.841 10.1029 48.9085L39.4793 11.1388C39.9456 10.5171 40.7228 10.0508 41.4999 10.0508C42.2771 10.0508 43.0542 10.5171 43.5205 11.1388L72.8969 48.9085C73.6741 49.841 73.5186 51.3953 72.4306 52.1725C71.498 52.9497 70.0992 52.7942 69.1666 51.7062L43.8314 19.2212V133.774C43.8314 135.017 42.7434 136.105 41.4999 136.105C40.2565 136.105 39.1685 135.017 39.1685 133.774V19.2212Z"
                        fill="black"
                      />
                      <path
                        d="M2.33146 5.05062C1.08801 5.05062 0 3.9626 0 2.71916C0 1.47571 1.08801 0.387695 2.33146 0.387695H80.6685C81.912 0.387695 83 1.47571 83 2.71916C83 3.9626 81.912 5.05062 80.6685 5.05062H2.33146Z"
                        fill="black"
                      />
                    </svg>
                    <input type="file" onChange={(e) => handleImageUpload(e)} />
                    <img
                      src={userData?.image ? userData?.image : d1}
                      alt="img"
                    />
                  </div>
                </div>
                <div> {userData?.name}</div>
              </div>
              <div className="flx">
                <div>
                  <span className="gry">Email Address</span>
                  <p>{userData?.email}</p>
                </div>
                <div>
                  <span className="gry">
                    Email Verification{" "}
                    {/* <svg
                      width="5"
                      height="8"
                      viewBox="0 0 5 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.482508 0.24618C0.528931 0.199714 0.584057 0.162853 0.644734 0.137704C0.705411 0.112554 0.77045 0.0996094 0.836133 0.0996094C0.901815 0.0996094 0.966854 0.112554 1.02753 0.137704C1.08821 0.162853 1.14333 0.199714 1.18976 0.24618L4.18976 3.24618C4.23622 3.2926 4.27308 3.34773 4.29823 3.40841C4.32338 3.46908 4.33633 3.53412 4.33633 3.5998C4.33633 3.66549 4.32338 3.73053 4.29823 3.7912C4.27308 3.85188 4.23622 3.90701 4.18976 3.95343L1.18976 6.95343C1.14332 6.99987 1.08819 7.0367 1.02751 7.06184C0.966838 7.08697 0.901807 7.09991 0.836133 7.09991C0.770458 7.09991 0.705427 7.08697 0.644752 7.06184C0.584077 7.0367 0.528946 6.99987 0.482508 6.95343C0.436069 6.90699 0.399232 6.85186 0.374099 6.79118C0.348967 6.73051 0.336032 6.66548 0.336032 6.5998C0.336032 6.53413 0.348967 6.4691 0.374099 6.40842C0.399232 6.34775 0.436069 6.29262 0.482508 6.24618L3.12888 3.5998L0.482508 0.953429C0.436042 0.907006 0.399181 0.85188 0.374032 0.791203C0.348882 0.730526 0.335938 0.665487 0.335938 0.599805C0.335938 0.534122 0.348882 0.469083 0.374032 0.408406C0.399181 0.347729 0.436042 0.292603 0.482508 0.24618Z"
                        fill="#8C8C8C"
                        fillOpacity="0.6"
                      ></path>
                    </svg> */}
                  </span>
                  <p>
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.214844 7.7002C0.214844 9.55671 0.952342 11.3372 2.2651 12.6499C3.57785 13.9627 5.35833 14.7002 7.21484 14.7002C9.07136 14.7002 10.8518 13.9627 12.1646 12.6499C13.4773 11.3372 14.2148 9.55671 14.2148 7.7002C14.2148 5.84368 13.4773 4.0632 12.1646 2.75045C10.8518 1.43769 9.07136 0.700195 7.21484 0.700195C5.35833 0.700195 3.57785 1.43769 2.2651 2.75045C0.952342 4.0632 0.214844 5.84368 0.214844 7.7002ZM7.21484 3.9842C7.71084 3.9842 7.95884 4.2322 7.95884 4.7282V8.3152C7.95884 8.8112 7.71084 9.05919 7.21484 9.05919C6.71884 9.05919 6.47084 8.8112 6.47084 8.3152V4.7282C6.47084 4.2322 6.71884 3.9842 7.21484 3.9842ZM7.21484 9.5842C7.79818 9.5842 8.08984 9.87586 8.08984 10.4592C8.08984 11.0425 7.79818 11.3342 7.21484 11.3342C6.63151 11.3342 6.33984 11.0425 6.33984 10.4592C6.33984 9.87586 6.63151 9.5842 7.21484 9.5842Z"
                        fill={userData?.email_verify ? "green" : "red"}
                      ></path>
                    </svg>
                    <span
                      style={{
                        color: userData?.email_verify ? "green" : "red",
                      }}
                    >
                      {userData?.email_verify ? "Verified" : "Not Verified"}
                    </span>
                  </p>
                </div>

                <div>
                  <span className="gry">
                    Kyc Verification{" "}
                    {/* <svg
                      width="5"
                      height="8"
                      viewBox="0 0 5 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.482508 0.24618C0.528931 0.199714 0.584057 0.162853 0.644734 0.137704C0.705411 0.112554 0.77045 0.0996094 0.836133 0.0996094C0.901815 0.0996094 0.966854 0.112554 1.02753 0.137704C1.08821 0.162853 1.14333 0.199714 1.18976 0.24618L4.18976 3.24618C4.23622 3.2926 4.27308 3.34773 4.29823 3.40841C4.32338 3.46908 4.33633 3.53412 4.33633 3.5998C4.33633 3.66549 4.32338 3.73053 4.29823 3.7912C4.27308 3.85188 4.23622 3.90701 4.18976 3.95343L1.18976 6.95343C1.14332 6.99987 1.08819 7.0367 1.02751 7.06184C0.966838 7.08697 0.901807 7.09991 0.836133 7.09991C0.770458 7.09991 0.705427 7.08697 0.644752 7.06184C0.584077 7.0367 0.528946 6.99987 0.482508 6.95343C0.436069 6.90699 0.399232 6.85186 0.374099 6.79118C0.348967 6.73051 0.336032 6.66548 0.336032 6.5998C0.336032 6.53413 0.348967 6.4691 0.374099 6.40842C0.399232 6.34775 0.436069 6.29262 0.482508 6.24618L3.12888 3.5998L0.482508 0.953429C0.436042 0.907006 0.399181 0.85188 0.374032 0.791203C0.348882 0.730526 0.335938 0.665487 0.335938 0.599805C0.335938 0.534122 0.348882 0.469083 0.374032 0.408406C0.399181 0.347729 0.436042 0.292603 0.482508 0.24618Z"
                        fill="#8C8C8C"
                        fillOpacity="0.6"
                      ></path>
                    </svg> */}
                  </span>
                  <p>
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.214844 7.7002C0.214844 9.55671 0.952342 11.3372 2.2651 12.6499C3.57785 13.9627 5.35833 14.7002 7.21484 14.7002C9.07136 14.7002 10.8518 13.9627 12.1646 12.6499C13.4773 11.3372 14.2148 9.55671 14.2148 7.7002C14.2148 5.84368 13.4773 4.0632 12.1646 2.75045C10.8518 1.43769 9.07136 0.700195 7.21484 0.700195C5.35833 0.700195 3.57785 1.43769 2.2651 2.75045C0.952342 4.0632 0.214844 5.84368 0.214844 7.7002ZM7.21484 3.9842C7.71084 3.9842 7.95884 4.2322 7.95884 4.7282V8.3152C7.95884 8.8112 7.71084 9.05919 7.21484 9.05919C6.71884 9.05919 6.47084 8.8112 6.47084 8.3152V4.7282C6.47084 4.2322 6.71884 3.9842 7.21484 3.9842ZM7.21484 9.5842C7.79818 9.5842 8.08984 9.87586 8.08984 10.4592C8.08984 11.0425 7.79818 11.3342 7.21484 11.3342C6.63151 11.3342 6.33984 11.0425 6.33984 10.4592C6.33984 9.87586 6.63151 9.5842 7.21484 9.5842Z"
                        fill={userData?.kyc_verify == "true" ? "green" : "red"}
                      ></path>
                    </svg>
                    <span
                      style={{
                        color: userData?.kyc_verify == "true" ? "green" : "red",
                      }}
                    >
                      {userData?.kyc_verify == "true"
                        ? "Verified"
                        : "Not Verified"}
                    </span>
                  </p>
                </div>

                <div>
                  <span className="gry">Referral Id</span>
                  <div className="display-1 cursor">
                    <div
                      className="d-flex"
                      onClick={() => handleCopyAcc(userData?.referral_code)}
                    >
                      <Copy />
                    </div>
                    <div> {userData?.referral_code} </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-4">
              <Grid container spacing={3}>
                {assetData.map((row, i) => (
                  <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
                    <div className="asset_box box_bdr">
                      <p className={` ${imghide[i].show ? "show" : "hide"}`}>
                        {row.title}
                        <span
                          className="cusrsor-pointer"
                          onClick={() => showimg(i)}
                        >
                          {imghide[i]?.show ? (
                            <img src={eye} alt="img" />
                          ) : (
                            <img src={eye_hide} alt="img" />
                          )}
                        </span>
                      </p>
                      <h2>{imghide[i].show ? totalUSDT : "*****"} USDT </h2>
                      <div className="flx">
                        {row.depositLink && (
                          <Link to={row.depositLink} className="org_btn radius">
                            Deposit
                          </Link>
                        )}
                        {row.earnLink && (
                          <Link to={row.earnLink} className="org_btn radius">
                            Earn Rewards
                          </Link>
                        )}
                        {row.ReferNow && (
                          <Link to={row.ReferNow} className="org_btn radius">
                            Refer Now
                          </Link>
                        )}
                        {row.withdrawLink && (
                          <Link
                            to={row.withdrawLink}
                            className="bdr_btn radius"
                          >
                            Withdraw
                          </Link>
                        )}
                      </div>
                    </div>
                  </Grid>
                ))}
              </Grid>
            </div>
            <div>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="custom_table box_bdr">
                    <div className="h_flx flex-wrap" style={{ gap: "10px" }}>
                      <h3>Spot Assets</h3>
                      <div className="input_box">
                        <TextField
                          fullWidth
                          placeholder="Currency Name, Symbol"
                          sx={{
                            width: "240px",
                            borderRadius: "50px",
                            "& .MuiInputBase-formControl": {
                              borderRadius: "50px",
                            },
                            "& .MuiInputBase-input": {
                              padding: "11px  0 11px 30px",
                              border: "0",
                            },
                            "& fieldset": {
                              border: "1px solid #d3d1d1 !important",
                            },
                            "& .MuiInputBase-input::placeholder": {
                              color: "black",
                              fontSize: "15px",
                            },
                          }}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <svg
                                  width="18"
                                  height="19"
                                  viewBox="0 0 18 19"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clip-path="url(#clip0_55_24278)">
                                    <path
                                      d="M16.6 18.3984L10.3 12.0984C9.8 12.4984 9.225 12.8151 8.575 13.0484C7.925 13.2817 7.23333 13.3984 6.5 13.3984C4.68333 13.3984 3.14583 12.7692 1.8875 11.5109C0.629167 10.2526 0 8.7151 0 6.89843C0 5.08177 0.629167 3.54427 1.8875 2.28593C3.14583 1.0276 4.68333 0.398438 6.5 0.398438C8.31667 0.398438 9.85417 1.0276 11.1125 2.28593C12.3708 3.54427 13 5.08177 13 6.89843C13 7.63177 12.8833 8.32343 12.65 8.97343C12.4167 9.62343 12.1 10.1984 11.7 10.6984L18 16.9984L16.6 18.3984ZM6.5 11.3984C7.75 11.3984 8.8125 10.9609 9.6875 10.0859C10.5625 9.21093 11 8.14843 11 6.89843C11 5.64843 10.5625 4.58593 9.6875 3.71093C8.8125 2.83593 7.75 2.39843 6.5 2.39843C5.25 2.39843 4.1875 2.83593 3.3125 3.71093C2.4375 4.58593 2 5.64843 2 6.89843C2 8.14843 2.4375 9.21093 3.3125 10.0859C4.1875 10.9609 5.25 11.3984 6.5 11.3984Z"
                                      fill="#1E2329"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_55_24278">
                                      <rect
                                        width="18"
                                        height="19"
                                        fill="white"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </div>
                    </div>
                    <div className="switch_box">
                      <FormControlLabel
                        control={
                          <Switch
                            checked={hideZero}
                            onChange={(e) => setHideZero(e.target.checked)}
                            sx={{
                              "& .Mui-checked": { color: "#566FFF !important" },
                              "& .Mui-checked+.MuiSwitch-track": {
                                backgroundColor: "#8f9ff7 !important",
                              },
                              "& .MuiFormControlLabel-label": {
                                fontSize: "12px",
                              },
                            }}
                          />
                        }
                        label="Hide Zero Balance"
                      />
                    </div>

                    <TableContainer sx={{ marginBottom: "10px" }}>
                      <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell>S.No</TableCell>
                            <TableCell>Currency Symbol</TableCell>
                            <TableCell>Currency Name</TableCell>
                            <TableCell>Available Balance</TableCell>
                            <TableCell>Escrow Balance</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {walletLoading == true ? (
                            <TableRow>
                              <TableCell colSpan={8}>
                                <div className="model-load">
                                  <Loader />
                                </div>
                              </TableCell>
                            </TableRow>
                          ) : (
                            datas?.length == 0 && (
                              <TableRow>
                                <TableCell colSpan={8}>
                                  <div
                                    className="model-load"
                                    style={{
                                      color: "white",
                                      textAlign: "center",
                                    }}
                                  >
                                    No Data Found
                                  </div>
                                </TableCell>
                              </TableRow>
                            )
                          )}
                          {datas?.length > 0 &&
                            datas?.map((row, index) => (
                              <TableRow key={row._id} className="tr_row">
                                <TableCell>
                                  {page == 0
                                    ? index + 1
                                    : page * 10 + index + 1}
                                </TableCell>
                                <TableCell>
                                  <div className="d-flex align-items-center display-1">
                                    {/* <Avatar sx={{ width: 24, height: 24 }}>  {row?.symbol?.split('')[0]}</Avatar> */}
                                    <ImageWithFallback
                                      src={
                                        row?.image
                                          ? row?.image
                                          : `${consts?.imageurl}${row?.symbol}.png`
                                      }
                                      alt={row.assetname}
                                      name={row?.assetname}
                                      size={30}
                                      style={{
                                        width: "30px",
                                        height: "30px",
                                        marginRight: "10px",
                                        borderRadius: "50%",
                                      }}
                                    />
                                    {row?.symbol}
                                  </div>
                                </TableCell>
                                <TableCell>{row?.assetname}</TableCell>
                                <TableCell>
                                  <div className="table-diff">
                                    <div>
                                      {Number(row?.spot_balance).toFixed(6)}
                                    </div>
                                    <div className="dim-clr">
                                      {row?.usdtValue_available
                                        ? `${row?.usdtValue_available} USD`
                                        : "0 USD"}
                                    </div>
                                  </div>
                                </TableCell>
                                <TableCell>
                                  <div className="table-diff">
                                    <div>
                                      {Number(
                                        row?.escrow_spot_balance
                                      )?.toFixed(6)}
                                    </div>
                                    <div className="dim-clr">
                                      {row?.usdtValue_escrow
                                        ? `${row?.usdtValue_escrow} USD`
                                        : "0 USD"}
                                    </div>
                                  </div>
                                </TableCell>
                              </TableRow>
                            ))}
                        </TableBody>
                      </Table>
                      <TablePagination
                        rowsPerPageOptions={[]} // Options for rows per page
                        component="div"
                        count={totalCount} // Total number of filtered rows
                        rowsPerPage={10}
                        page={page}
                        onPageChange={handleChangePage}
                      // onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    </TableContainer>
                  </div>
                </Grid>
              </Grid>
            </div>
          </div>
        </div>
      </div>
      <Footernew />
    </div>
  );
}
